<template>
  <v-row justify="center">
    <v-btn
      large
      text
      block
      class="ma-auto"
      @click="dialog = true"
    >
      Ejercicios
    </v-btn>

    <v-dialog
      v-model="dialog"
      width="420"
    >
      <v-card>
        <v-card-title class="h2">
          Lista de Ejercicios Nivel {{ item + 1 }}
        </v-card-title>
        <v-card-text>{{levelDifficulty[item]}}</v-card-text>
        <v-card-text>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                v-for="(exercise, index) in listsExercises.exercises"
                :key="index"
                class="mb-2"
              >
                {{ index + 1 }}) {{ exercise.multiplicand }} * {{ exercise.multiplier }} = {{ multiplication(exercise.multiplicand, exercise.multiplier) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <!-- <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Copiar
          </v-btn> -->

          <!-- <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cerrar
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import firebase from 'firebase/app'
  import axios from 'axios'
  export default {
    props: {
      item: {
        type: Number,
        default: 1,
        quizzesDownloadUrl: 'https://us-central1-videojuego-sh.cloudfunctions.net/quizzesDownloadUrl',
      },
    },
    data () {
      return {
        dialog: false,
        listsExercises: {
          listsExercises: [],
        },
        levelDifficulty : 
        [
            "Niv. 1) “Tipo de multiplicaciones: 1X1 y 2X1 dígitos”.",
            "Niv. 2) “Tipo de multiplicaciones: 3X1 dígitos”.",
            "Niv. 3) “Tipo de multiplicaciones: 4X1 dígitos”.",
            "Niv. 4) “Tipo de multiplicaciones: 2X2 dígitos”.",
            "Niv. 5) “Tipo de multiplicaciones: 1X2, 2X2 y 1X3 dígitos (decenas completas)”.",
            "Niv. 6) “Tipo de multiplicaciones: 2X3 dígitos (centenas completas)”.",
            "Niv. 7) “Tipo de multiplicaciones: 3X2 dígitos (decenas completas)”.",
            "Niv. 8) “Tipo de multiplicaciones: 3X2 y 1X4 dígitos (decenas completas)”.",                    
        ]
      }
    },
    async mounted () {
      const storage = firebase.storage()
      const storageRef = storage.ref()
      const objectRef = storageRef.child(`Quizzes/Ejercicios${this.item + 1}.json`)

      const url = await objectRef.getDownloadURL()
      const response = await axios.get(url)
      this.listsExercises = response.data
    },
    methods: {
      multiplication (m1, m2) {
        return m1 * m2
      },
    },
  }
</script>
